import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { ConfigService } from '../config.service';
import { TripsSub, TripsSubNotes } from './commonInterfaces';
import { DataTransform, DateField } from './dataTransformFunctions';
import { McDataMapService } from './mc-data-map.service';


export interface SubtripUpdatedArgs {
  subtrip: TripsSub
  
}

@Injectable({
  providedIn: 'root'
})
export class SubtripService {

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private mcDataMapService: McDataMapService
  ) { }

  subtripUpdated: Subject<SubtripUpdatedArgs> = new Subject<SubtripUpdatedArgs>()

  readonly subtripDateFields: DateField<TripsSub>[] = [{dateType: "utc", fieldName: "timestamp"}]


  getSubtripsForTrip(tripId: number): Observable<TripsSub[]> {
    return this.http.get<TripsSub[]>(`${this.config.dataApiUrl}/trips/${tripId.toString()}/subtrips`).pipe(
      switchMap(subtrips => {
        return DataTransform.replaceDatesArray<TripsSub>(subtrips, this.subtripDateFields)
      })
    )
  }

  getSubtrip(subtripId: string): Observable<TripsSub> {
    return this.http.get<TripsSub>(`${this.config.dataApiUrl}/subtrips/${subtripId}`).pipe(
      switchMap(subtrip => {
        return DataTransform.replaceDates<TripsSub>(subtrip, this.subtripDateFields)
      })
    )
  }

  updateSubtrip(subtripId: string, data: Partial<TripsSub & {notes: Omit<TripsSubNotes, 'id'| 'subtripId'>[]}>) {
      return this.http.patch<TripsSub>(`${this.config.dataApiUrl}/subtrips/${subtripId}`, data).pipe(
        switchMap(subtrip => {
          return DataTransform.replaceDates<TripsSub>(subtrip, this.subtripDateFields )
        }),
        tap(subtrip => {
          this.subtripUpdated.next({subtrip: {...subtrip}})
        })
      )
  }

  getSubtripNotes(subtripId: string): Observable<TripsSubNotes[]> {
    return this.http.get<TripsSubNotes[]>(`${this.config.dataApiUrl}/subtrips/${subtripId}/notes`)
  }


  emptySubtrip(): TripsSub {
    return {
      id: "-1",
      itineraryPublic: 0,
      itineraryUrl: "",
      lodging: "",
      lodgingConfirmed: 0,
      meals: "",
      mealsConfirmed: 0,
      recLodging: "",
      recLodgingConfirmed: 0,
      recreation: "",
      recreationConfirmed: 0,
      subtripName: "",
      timestamp: new Date(1000, 0, 1),
      translator: "",
      translatorConfirmed: 0,
      transportation: "",
      transportationConfirmed: 0,
      tripId: 0,
      vehicle: "",
      vehicleConfirmed: 0,
      tlLocalOverride: 0,
      atl1: 0,
      atl1Confirmed: 0,
      atl1LocalOverride: 0,
      atl2: 0,
      atl2Confirmed: 0,
      atl2LocalOverride: 0,
      atl3: 0,
      atl3Confirmed: 0,
      atl3LocalOverride: 0,
      atl4: 0,
      atl4Confirmed: 0,
      atl4LocalOverride: 0,
      atl5: 0,
      atl5Confirmed: 0,
      atl5LocalOverride: 0,
      atl6: 0,
      atl6Confirmed: 0,
      atl6LocalOverride: 0,
      atl7: 0,
      atl7Confirmed: 0,
      atl7LocalOverride: 0,
      atl8: 0,
      atl8Confirmed: 0,
      atl8LocalOverride: 0,
      atl9: 0,
      atl9Confirmed: 0,
      atl9LocalOverride: 0,
      atl10: 0,
      atl10Confirmed: 0,
      atl10LocalOverride: 0,
      atl11: 0,
      atl11Confirmed: 0,
      atl11LocalOverride: 0,
      atl12: 0,
      atl12Confirmed: 0,
      atl12LocalOverride: 0,
      atl13: 0,
      atl13Confirmed: 0,
      atl13LocalOverride: 0,
      atl14: 0,
      atl14Confirmed: 0,
      atl14LocalOverride: 0,
      atl15: 0,
      atl15Confirmed: 0,
      atl15LocalOverride: 0,
      atl16: 0,
      atl16Confirmed: 0,
      atl16LocalOverride: 0,
    }
  }

}
